import { KeyValuePipe } from '@angular/common';
import { Component, computed, input } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';
import { FORM_FIELD_DEFAULT_ERRORS_MSG } from '@shared/constants';
import { Dict } from '@shared/models';

@Component({
  imports: [KeyValuePipe],
  selector: 'b2c-form-field-errors',
  styleUrl: './field-errors.component.scss',
  templateUrl: './field-errors.component.html',
})
export class FieldErrorsComponent {
  errorStyles = input<Dict>({});
  id = input<string | number>('');
  errorMessages = input<Dict>({});
  serverErrorMessage = input<string>('');
  control = input<AbstractControl>(new FormControl());

  errorMessagesValue = computed(() => {
    return {
      ...FORM_FIELD_DEFAULT_ERRORS_MSG,
      ...this.errorMessages(),
    };
  });
}
